import ApiService from "./ApiService";
import {
	CriteriaRisksDeleteRelationResponse,
	CriteriaRisksGetResponse,
	CriteriaRisksManifestationsDeleteRelationResponse,
	CriteriaRisksManifestationsRelationsPostRequest,
	CriteriaRisksManifestationsRelationsPostResponse,
	CriteriaRisksPostRequest,
	CriteriaRisksPostResponse,
	CriteriaRisksPutRequest,
	CriteriaRisksPutResponse,
	CriteriaRisksRelationsPostRequest,
	CriteriaRisksRelationsPostResponse,
} from "src/entities/CriteriaRiskEntity";

export const criteriaRiskQueryKeys = {
	risks: (id: string) => ["criteria", id, "risks"] as const,
};

export default class CriteriaRiskService extends ApiService {
	public async getRisks(criteriaId: number) {
		return await this.request.get<CriteriaRisksGetResponse>(`/api/v1/criteria/${criteriaId}/risks`);
	}
	public async postRisk(data: CriteriaRisksPostRequest) {
		return await this.request.post<CriteriaRisksPostResponse>(`/api/v1/criteria/risks`, data);
	}
	public async putRisk(data: CriteriaRisksPutRequest) {
		return await this.request.put<CriteriaRisksPutResponse>(`/api/v1/criteria/risks`, data);
	}
	public async postRiskRelations(data: CriteriaRisksRelationsPostRequest) {
		return await this.request.post<CriteriaRisksRelationsPostResponse>(`/api/v1/criteria/risks/relations`, data);
	}
	public async deleteRiskRelation(criteriaId: number, riskId: number) {
		return await this.request.delete<CriteriaRisksDeleteRelationResponse>(`/api/v1/criteria/${criteriaId}/risks/${riskId}/relations`);
	}
	public async postRiskManifestationRelations(data: CriteriaRisksManifestationsRelationsPostRequest) {
		return await this.request.post<CriteriaRisksManifestationsRelationsPostResponse>(`/api/v1/criteria/risks/manifestations/relations`, data);
	}
	public async deleteRiskManifestationRelation(riskId: number, manifestationId: number) {
		return await this.request.delete<CriteriaRisksManifestationsDeleteRelationResponse>(`/api/v1/criteria/risks/${riskId}/manifestations/${manifestationId}/relations`);
	}
}
